// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import * as config from '../app/config/config';
export const environment = {
  production: false,
  imgUrl : "https://app.test.mycareplan.health/assets/images/",
  auth0Config: {
    clientID: 's00gr2yGRCbdhqTvtywJkTluh1rAbsEy',
    domain: 'mycareplan-dev.auth0.com',
    responseType: 'token id_token',
    redirectUri: 'https://app.test.mycareplan.health/callback',
    audience: 'https://mycareplan.health/api/v1/',
    scope: 'openid email profile read:current_user update:current_user_identities ' + config.getScope()
  },
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "",
  },
  auth0Cerner:{
    connection: 'Cerner',
    responseType: 'token',
    redirectUri: 'https://app.test.mycareplan.health/app/clinical-information/cerner'
  },
  auth0Epic:{
    connection: 'Epic',
    responseType: 'token',
    redirectUri: 'https://app.test.mycareplan.health/app/clinical-information/cerner'
  },
  baseUrl: {
    campaign: 'https://campaign-service.test.mycareplan.health/',
    offer: 'https://offer-service.test.mycareplan.health/',
    reward: 'https://reward-service.test.mycareplan.health/',
    drawing: 'https://drawing-service.test.mycareplan.health/',
    awardRule: 'https://drawing-service.test.mycareplan.health/',
    questionnaire: 'https://questionnaire-service.test.mycareplan.health/',
    message: 'https://communication-service.test.mycareplan.health/',
    template: 'https://dashboard-service.test.mycareplan.health/',
    doctors: "https://userservice-6va6tek4qa-uc.a.run.app/api/",
    common: "https://appointmentservice-6va6tek4qa-uc.a.run.app/api/",
    schedule: "https://appointment-service.onehealth.test.mycareplan.health/",
    slot: "https://appointment-service.onehealth.test.mycareplan.health/",
    appointment: "https://appointment-service.onehealth.test.mycareplan.health/"
  },
  patientIdUrl: 'https://app.test.mycareplan.health/patient_id',
  drawingWinningPageUrl: 'https://app.test.mycareplan.health/winners',
  tenant: {
    sidebarLogoUrl: "",
    logo: ""
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
